import Marionette from "backbone.marionette";
import LoginTpl from "views/login/loginView.ejs";
import ForgotTpl from "views/login/forgotView.ejs";
// import LoginCSS from "views/login/login.css";

import RecoverModel from "models/recoverModel.js";

import T from "session/token.js";
import S from "session/session.js";

require("../../../application/adminlte/dist/js/adminlte.js");
require("icheck");

export default Marionette.View.extend({
    initialize: function () {
        this.listenTo(S.mApp, "access:pass", function () {
            $("body").removeClass().addClass("hold-transition skin-black fixed layout-top-nav");
            $(".main-sidebar").hide();                        
            S.mApp.start();
        });

        this.listenTo(S.mApp, "access:fail", function () {
            S.mApp.trigger("notify:error", {
                message: this.collection.models[0].attributes.NOUSER
            });

            $("#loaderContainer").hide();
        }.bind(this));

        this.listenTo(S.mApp, "access:failuser", function () {
            S.mApp.trigger("notify:error", {
                message: this.collection.models[0].attributes.EMAXUSERCONNECT
            });

            $("#loaderContainer").hide();
        }.bind(this));


        this.model = new RecoverModel();
    },
    template: LoginTpl,
    forgotTemplate: ForgotTpl,
    render: function () {
        //TODO: Language for login?
        this.$el.html(this.template(this.collection.models[0]));
        $("body").removeClass().addClass("hold-transition login-page");
    },
    onShow: function(){
        $('input[type="checkbox"], input[type="radio"]').iCheck({
            checkboxClass: 'icheckbox_square-blue',
            radioClass: 'iradio_square-blue'
        });  
    },
    events: {
        "click #loginButton": "login",
        "click #forgotButton": "recover",
        "click #forgot": "forgot"
    },
    login: function (ev) {
        ev.preventDefault();

        var data = {
            username: $("#username").val(),
            password: $("#password").val(),
            remember: $("#rememberMe").is(":checked")
        };

        T.getToken(data);

        return false;
    },
    forgot: function (ev) {
  
        this.$el.html(this.forgotTemplate(this.collection.models[0]));
    },
    recover: function (ev) {
        ev.preventDefault();
        var username = $("#username").val();
        
        this.model.save({
            username: username,
            lang: navigator.language || navigator.userLanguage
        }, {
            success: function () {
                S.mApp.trigger("notify:success", {
                    message: this.collection.models[0].attributes.MAIL_SENT
                })
            }.bind(this),
            error: function (model, response) {
                S.mApp.trigger("notify:error", {
                    message: this.collection.models[0].attributes.MAIL_ERROR
                })
            }.bind(this)
        });
        return false;
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/login/loginView.js
// module id = 189
// module chunks = 0